import { ZodProvider } from "@autoform/zod";

import { AutoForm } from "@/components/ui/autoform";
import { injectCustomAutoFormComponents } from "@/components/ui/autoform/components/custom";
import { RemoteSelect } from "@/components/fields/remote-select";
import { Separator } from "@/components/ui/separator";
import { useVenueCreateForm } from "@/pages/venues/create/hooks/use-venue-create-form";
import { basicVenueSchema } from "@/pages/venues/schemas/venue.create.form";

const schemaProvider = new ZodProvider(basicVenueSchema);

export const VenueCreateBasicInfoStep = () => {
  const { onPlaceSelected, searchPlace, basicInfoStep, onBasicInfoStepSubmit } =
    useVenueCreateForm();

  return (
    <div className="flex flex-col gap-2">
      <div className="w-3/4 flex flex-col space-y-4">
        <RemoteSelect
          value={basicInfoStep?.place}
          onValueChanged={onPlaceSelected}
          onSearch={searchPlace}
          label="Google Places Search API"
          accessorFn={(option) => {
            if (!option) {
              return;
            }
            return {
              id: option.id,
              name: `${option.displayName.text} @ ${option.shortFormattedAddress}`,
              number: `${option.rating} ⭐️`,
            };
          }}
        />
      </div>
      <Separator />
      <AutoForm
        schema={schemaProvider}
        values={basicInfoStep}
        onSubmit={onBasicInfoStepSubmit}
        withSubmit
        {...injectCustomAutoFormComponents()}
      ></AutoForm>
    </div>
  );
};
